module.exports = __webpack_public_path__ + "static/media/ic-ads.65dca526.svg";